import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
	// mode: "history",
	routes: [{
			path: '/',
			// redirect: '/eduweb',
			name: 'home',
			component: () => import("@/views/home/index"),
		},
		{
			path: '/contactdetails',
			name: 'contactdetails',
			component: () => import("@/views/contactdetails/index"),
		},
		{
			path: '/downloading',
			name: 'downloading',
			component: () => import("@/views/downloading/index"),
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js